import StorefrontIcon from '@mui/icons-material/Storefront';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import SpaIcon from '@mui/icons-material/Spa';

const ICON_BY_SCHEME = {
  gym: StorefrontIcon,
  barber: ContentCutIcon,
  spa: SpaIcon,
};

const SERVICE_LABEL_BY_SCHEME = {
  gym: 'Services',
  barber: 'Services',
  spa: 'Treatments',
};

const BOOK_LABEL_BY_SCHEME = {
  gym: 'Book Session',
  barber: 'Book Appointment',
  spa: 'Book Treatment',
};

export const getSchemeIcon = (scheme) => ICON_BY_SCHEME[scheme] || StorefrontIcon;
export const getServiceLabel = (scheme) => SERVICE_LABEL_BY_SCHEME[scheme] || 'Services';
export const getBookLabel = (scheme) => BOOK_LABEL_BY_SCHEME[scheme] || 'Book Session';
